import { Component, OnInit } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, FormBuilder, Validators } from '@angular/forms';
import { UserService, OperationsService, AuthenticationService, StorageService } from '../../_services';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-generalledger',
  templateUrl: './generalledger.component.html',
  styleUrls: ['./generalledger.component.css']
})
export class GeneralledgerComponent implements OnInit {

  public currentUser: any;
  public loading = false;
  public filter = { DDATE: '', DDATE_: '' }
  public data: any;
  public start_date: any;
  public end_date: any;
  public accounts: any;
  SHOW_ZERO_BALANCE:any;
  TYPES:any;
  
  constructor(public fb: FormBuilder, public operationsService: OperationsService, public storageService: StorageService, public toastr: ToastrService) {
    this.currentUser = this.storageService.read<any>('currentUser');

  }


  ngOnInit() {
    this.loadLedgerReports();
  }
  showError(msg) {
    return this.toastr.error(msg, 'Error');
  }
  loadLedgerReports() {
    const start_date = this.start_date;
    const end_date = this.end_date;
    this.loading = true
    this.operationsService.loadGeneralLedgerReports(this.currentUser.token, start_date, end_date, 1).subscribe(res => {
      if (res) {
        this.loading = false;
        this.accounts = res.final.accounts;
      } else {
        this.loading = false;
        this.showError(res.response);
      }
    }, () => {
      this.loading = false;
      this.showError('An error occurred, try again');
    });
  }
}
